// extracted by mini-css-extract-plugin
export default {"leftSideBtn":"ViewButtons_leftSideBtn__M+YDd","leftSideBtnContainer":"ViewButtons_leftSideBtnContainer__YqJaj","rightSideBtn":"ViewButtons_rightSideBtn__LzDgm"};